import Layout from 'layout';
import SpecializeReviewFormCreate from 'features/SpecializeReview/pages/Create';
import { LayoutProvider } from '../layout/context/layoutcontext';

function SpecializeReviewFormCreatePage() {
  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
          backgroundColor: 'white',
        }}
      >
        <SpecializeReviewFormCreate />
      </Layout>
    </LayoutProvider>
  );
}

export default SpecializeReviewFormCreatePage;
